export default __webpack_public_path__ + "assets/models/a1b22974f9c20e08a112c87b0a446cf4.glb";